//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  CheckSquareIcon,
  TagIcon
} from 'vue-feather-icons'
import TaskDetailsLocation from '@/components/tasks/TaskDetailsLocation'
import TaskDetailsStatus from '@/components/tasks/TaskDetailsStatus'
import TaskDetailsDuration from '@/components/tasks/TaskDetailsDuration'
import TaskDetailsValue from '@/components/tasks/TaskDetailsValue'
import TaskDetailsEscrow from '@/components/tasks/TaskDetailsEscrow'
import TaskDetailsApplications from '@/components/tasks/TaskDetailsApplications'
import TaskDetailsItem from '@/components/tasks/TaskDetailsItem'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'TaskDetails',
  components: {
    TaskDetailsItem,
    TaskDetailsApplications,
    TaskDetailsStatus,
    TaskDetailsDuration,
    TaskDetailsValue,
    TaskDetailsLocation,
    CheckSquareIcon,
    TagIcon,
    TaskDetailsEscrow
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    dateCreated () {
      return this.$moment(this.task.createdAt).format('MMM Do, yyyy')
    }
  }
}
